import { Feature } from 'ol';
import layerGeoImage from 'ol-ext/layer/GeoImage';
import sourceGeoImage from 'ol-ext/source/GeoImage';
import Polygon, { fromExtent } from 'ol/geom/Polygon';
import LayerGroup from 'ol/layer/Group';
import VectorLayer from 'ol/layer/Vector';
import { Vector } from 'ol/source';
import { Fill, Stroke, Style } from 'ol/style';
import Transform from 'ol-ext/interaction/Transform';
import { shiftKeyOnly, always } from 'ol/events/condition';
import { getCenter } from 'ol/extent';
import {
  degToRad,
  radToDeg,
  transformCoordinates,
  transformCoordinatesToLonLat
} from './utils';
import { ref } from 'vue-demi';

Transform.prototype.Cursors['rotate'] =
  "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXAgMAAACdRDwzAAAAAXNSR0IArs4c6QAAAAlQTFRF////////AAAAjvTD7AAAAAF0Uk5TAEDm2GYAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH2wwSEgUFmXJDjQAAAEZJREFUCNdjYMAOuCCk6goQpbp0GpRSAFKcqdNmQKgIILUoNAxIMUWFhoKosNDQBKDgVAilCqcaQBogFFNoGNjsqSgUTgAAM3ES8k912EAAAAAASUVORK5CYII=') 5 5, auto";
Transform.prototype.Cursors['rotate0'] =
  "url('data:image/png;base64,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') 5 5, auto";

export function usePlans(map) {
  const showedPlanIds = ref([]);
  const selectedPlanIds = ref([]);
  const editPlansState = ref({});
  const planGroupLayer = new LayerGroup({
    layers: []
  });
  const planEditGroupLayer = new LayerGroup({
    layers: []
  });

  const createImageSource = ({ url, rotation, center, width, height }) => {
    const source = new sourceGeoImage({
      url,
      imageCenter: transformCoordinates(center),
      imageScale: [0, 0],
      imageRotate: degToRad(rotation),
      projection: 'EPSG:3857'
    });
    source.once('change', evt => {
      const img = evt.target;
      const { width: imgWidth, height: imgHeight } = img._image;
      img.setScale(width / imgWidth, height / imgHeight);
    });

    return source;
  };

  const createPlanLayer = ({
    id,
    url,
    rotation,
    center,
    width,
    height,
    visible
  }) => {
    // create fake source for prevent download image
    const source = visible
      ? createImageSource({ url, rotation, center, width, height })
      : new sourceGeoImage({
          url: require('@/assets/pixel.png'),
          imageScale: [0, 0],
          imageCenter: [0, 0]
        });

    const layer = new layerGeoImage({
      name: 'Georef',
      source: source,
      visible: visible
    });
    layer.setProperties({ id, url, rotation, center, width, height });
    showedPlanIds.value = [
      ...new Set([...showedPlanIds.value, ...(visible ? [id] : [])])
    ]; // get unique ids
    return layer;
  };

  const updatePlanLayer = (layer, { center, width, height, rotation }) => {
    const img = layer.getSource();
    if (!img?._image) return;
    const { width: imgWidth, height: imgHeight } = img._image;
    img.setScale(width / imgWidth, height / imgHeight);
    img.setRotation(degToRad(rotation));
    img.setCenter(transformCoordinates(center));
  };

  const setPlans = plans => {
    const getPlanById = planId => plans.find(plan => plan.id === planId);

    const layerCollection = planGroupLayer.getLayers();
    const layerArr = layerCollection.getArray();

    // remove old plans
    for (let i = 0; i < layerArr.length; i++) {
      const plan = getPlanById(layerArr[i].get('id'));
      if (!plan || plan.url !== layerArr[i].get('url')) {
        layerCollection.remove(layerArr[i]);
        i--;
      }
    }

    plans.forEach(plan => {
      const layer = layerCollection
        .getArray()
        .find(layer => layer.get('id') === plan.id);
      if (!layer) {
        layerCollection.push(createPlanLayer(plan));
      } else if (layer.getVisible()) {
        updatePlanLayer(layer, plan);
      }
    });
    planGroupLayer.setLayers(layerCollection);
  };

  const selectPlans = ids => {
    selectedPlanIds.value = ids;
  };

  const showPlans = planIds => {
    planGroupLayer.getLayers().forEach(layer => {
      const visible = planIds.includes(layer.get('id'));
      if (visible) {
        const { url, rotation, center, width, height } = layer.getProperties();
        layer.setSource(
          createImageSource({ url, rotation, center, width, height })
        );
      }
      layer.setVisible(visible);
    });
  };

  const createEditLayer = imageLayer => {
    var vector = new VectorLayer({
      name: 'Vecteur',
      source: new Vector({ wrapX: false }),
      style: new Style({
        fill: new Fill({ color: [0, 0, 0, 0] }),
        stroke: new Stroke({ color: [0, 0, 0, 0], width: 1 })
      })
    });

    vector.setProperties({ id: imageLayer.get('id') });

    imageLayer.setOpacity(0.7);

    const img = imageLayer.getSource();
    const [width, height] = img._imageSize;
    const [sx, sy] = img.getScale();
    const rotation = img.getRotation();
    const center = img.getCenter();

    const polygon = new Polygon([
      [
        [0, 0],
        [width, 0],
        [width, height],
        [0, height]
      ]
    ]);

    polygon.translate(-width / 2 + center[0], -height / 2 + center[1]);

    polygon.scale(sx, sy);
    polygon.rotate(-rotation, center);

    //img.getRotation()
    vector.getSource().addFeature(new Feature(polygon));
    return vector;
  };

  const enableEditPlan = planId => {
    const planLayer = planGroupLayer
      .getLayers()
      .getArray()
      .find(layer => layer.get('id') === planId);

    if (!planLayer) {
      console.warn(`Unknown plan layer with planId: ${planId}`);
      return;
    }

    const editLayerCollection = planEditGroupLayer.getLayers();

    // if plan is being already edited
    if (
      editLayerCollection.getArray().find(layer => layer.get('id') === planId)
    ) {
      return;
    }

    const editLayer = createEditLayer(planLayer);
    editLayerCollection.push(editLayer);

    const interaction = new Transform({
      enableRotatedTransform: true,
      translateBBox: true,
      addCondition: shiftKeyOnly,
      hitTolerance: 2,
      translateFeature: true,
      scale: true,
      rotate: true,
      keepAspectRatio: always,
      translate: true,
      stretch: false,
      layers: [editLayer],
      selection: false
    });

    let startangle = 0;
    let startscale = [1, 1];

    const updateState = () => {
      const img = planLayer.getSource();
      const rotation = radToDeg(img.getRotation());
      const [centerLon, centerLat] = transformCoordinatesToLonLat(
        img.getCenter()
      );
      const [imgWidth, imgHeight] = img._imageSize;
      const [sx, sy] = img.getScale();
      const width = Math.abs(imgWidth * sx);
      const height = Math.abs(imgHeight * sy);
      updateEditPlanState(planId, {
        rotation,
        centerLat,
        centerLon,
        width,
        height
      });
    };

    interaction.on(['rotatestart', 'translatestart'], function() {
      // Rotation
      const img = planLayer.getSource();
      startangle = img.getRotation() || 0;
      updateState();
    });
    interaction.on('scalestart', function() {
      // Rotation
      const img = planLayer.getSource();
      startscale = img.getScale();
      updateState();
    });
    interaction.on('translating', function(e) {
      const img = planLayer.getSource();
      const center = img.getCenter();
      img.setCenter([center[0] + e.delta[0], center[1] + e.delta[1]]);
      updateState();
    });
    interaction.on('rotating', function(e) {
      const img = planLayer.getSource();
      img.setRotation(startangle - e.angle);
      updateState();
    });
    interaction.on('scaling', function(e) {
      const img = planLayer.getSource();
      const scalex = e.scale[0];
      const scaley = e.scale[1];
      img.setScale([startscale[0] * scalex, startscale[1] * scaley]);
      //fix center on scaling
      img.setCenter(getCenter(e.feature.getGeometry().getExtent()));
      updateState();
    });

    interaction.set('id', planId);

    map.addInteraction(interaction);

    interaction.select(editLayer.getSource().getFeatures()[0], true);
  };

  const updateEditPlanState = (
    planId,
    { width, height, rotation, centerLat, centerLon }
  ) => {
    editPlansState.value = {
      ...editPlansState.value,
      [planId]: {
        width,
        height,
        centerLat,
        centerLon,
        rotation
      }
    };
  };

  const disableEditPlan = planId => {
    const editLayerCollection = planEditGroupLayer.getLayers();
    const planLayer = planGroupLayer
      .getLayers()
      .getArray()
      .find(layer => layer.get('id') === planId);
    const plan = editLayerCollection
      .getArray()
      .find(layer => layer.get('id') === planId);
    if (!plan) {
      console.warn(`Unknown plan layer with planId: ${planId}`);
      return;
    }
    planLayer.setOpacity(1);
    editLayerCollection.remove(plan);
    const interaction = map
      .getInteractions()
      .getArray()
      .find(interaction => interaction.get('id') === planId);
    if (interaction) {
      map.removeInteraction(interaction);
    }
  };

  const getPlanById = planId => {
    return planGroupLayer
      .getLayers()
      .getArray()
      .find(layer => layer.get('id') === planId);
  };

  const setMapToPlanCenter = planId => {
    const plan = getPlanById(planId);
    if (plan) {
      map
        .getView()
        .animate({ center: plan.getSource().getCenter(), duration: 1000 });
      map.getView().fit(plan.getExtent(), {
        padding: [100, 100, 100, 100],
        duration: 1000
      });
    }
  };

  const getDefaultCenter = () => {
    const extent = map.getView().calculateExtent(map.getSize());
    const geom = fromExtent(extent);
    geom.scale(0.8);
    return transformCoordinatesToLonLat(getCenter(geom.getExtent()));
  };

  return {
    setPlans,
    showPlans,
    selectPlans,
    planGroupLayer,
    planEditGroupLayer,
    enableEditPlan,
    disableEditPlan,
    setMapToPlanCenter,
    showedPlanIds,
    selectedPlanIds,
    editPlansState,
    getDefaultCenter
  };
}
